<template>
<div>
    <div class="accordion accordion-toggle-arrow" id="userFilter">
        <div class="card" style="overflow:inherit">
            <div class="card-header bg-transparent" id="headingOne">
                <div class="card-title collapsed bg-white" data-toggle="collapse" 
                    data-target="#filterForm"
                    aria-controls="filterForm">
                    {{ $t('label.search') }}
                </div>
            </div>
            <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#userFilter">
                <div class="card-body bg-white">
                    <form @submit.prevent="action($event, query)">
                        <kt-form-section>
                            <kt-form-row>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="phone">
                                            {{ $t('label.phone') }}
                                        </kt-form-label>
                                        <kt-form-control ref="phone" dir="ltr" name="phone" id="phone" v-model="query.phone" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="full_name">
                                            {{ $t('label.full_name') }}
                                        </kt-form-label>
                                        <kt-form-control ref="full_name" name="full_name" id="full_name" v-model="query.full_name"></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group ref="statusSelectGroup">
                                        <kt-form-label for="status">
                                            {{ $t('label.status') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="status" class="form-control" name="status" v-model="query.status">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(status, index) in statuses"
                                                    v-bind:value="status.value"
                                                    :selected="query.status === status.value"
                                            >
                                                {{ status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                            <kt-form-row>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="email">
                                            {{ $t('label.email') }}
                                        </kt-form-label>
                                        <kt-form-control ref="email" dir="ltr" name="email" id="email" v-model="query.email" />
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="account_number">
                                            {{ $t('label.account_number') }}
                                        </kt-form-label>
                                        <kt-form-control ref="account_number" dir="ltr" name="account_number" id="account_number" v-model="query.account_number"></kt-form-control>
                                    </kt-form-group>
                                </kt-col>
                                <kt-col xs="12" sm="6" md="4">
                                    <kt-form-group>
                                        <kt-form-label for="gateway_status">
                                            {{ $t('label.gateway_status') }}
                                        </kt-form-label>
                                        <kt-form-select size="3" id="gateway_status" class="form-control" name="gateway_status" v-model="query.gateway_status">
                                            <option
                                                    v-bind:key="index"
                                                    v-for="(gateway_status, index) in gateway_statuses"
                                                    v-bind:value="gateway_status.value"
                                                    :selected="query.gateway_status === gateway_status.value"
                                            >
                                                {{ gateway_status.name }}
                                            </option>
                                        </kt-form-select>
                                    </kt-form-group>
                                </kt-col>
                            </kt-form-row>
                        </kt-form-section>
                        <kt-form-section>
                            <kt-row>
                                <kt-col xs="12" sm="6" md="6">
                                    <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                </kt-col>
                                <kt-col xs="12" sm="6" md="6">
                                    <button
                                        class="btn btn-success btn-wide float-right"
                                        size="md"
                                        type="button"
                                        id="export_btn"
                                        @click="exportExcel($event, query)"
                                    >
                                        {{ $t('btn.export_users_to_excel') }}
                                    </button>
                                </kt-col>
                            </kt-row>
                        </kt-form-section>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import $ from 'jquery'
import { userStatusStr, userStatus } from '@/constants/userStatus'
import { gatewayStatusStr, gatewayStatus } from '@/constants/gatewayStatus'

export default {
    props: {
        action: {
            default: function(e, query) {},
            required: true,
        },
        exportExcel: {
            default: function(e, query) {},
            required: true,
        }
    },
    data() {
        return {
            statuses: [
                {
                    name: null,
                    value: null
                },
                {
                    name: userStatusStr.ACTIVE,
                    value: userStatus.ACTIVE
                },
                {
                    name: userStatusStr.REMOVED,
                    value: userStatus.REMOVED
                },
                {
                    name: userStatusStr.PENDING,
                    value: userStatus.PENDING
                },
                {
                    name: userStatusStr.IS_AUTHENTICATED,
                    value: userStatus.IS_AUTHENTICATED
                },
                {
                    name: userStatusStr.IS_AUTHENTICATED_PENDING,
                    value: userStatus.IS_AUTHENTICATED_PENDING
                },
                {
                    name: userStatusStr.ENAMAD_AUTHENTICATED,
                    value: userStatus.ENAMAD_AUTHENTICATED
                },
                {
                    name: userStatusStr.TEMPORARY_BLOCK,
                    value: userStatus.TEMPORARY_BLOCK
                },
            ],
            gateway_statuses: [
                {
                    name: '',
                    value: ''
                },
                {
                    name: gatewayStatusStr.ACTIVE,
                    value: gatewayStatus.ACTIVE
                },
                {
                    name: gatewayStatusStr.PENDING,
                    value: gatewayStatus.PENDING
                },
                {
                    name: gatewayStatusStr.SEND_TO_SHAPARAK,
                    value: gatewayStatus.SEND_TO_SHAPARAK
                },
                {
                    name: gatewayStatusStr.REJECTED,
                    value: gatewayStatus.REJECTED
                },
                {
                    name: gatewayStatusStr.HAS,
                    value: gatewayStatus.HAS
                },
                {
                    name: gatewayStatusStr.DOES_NOT_HAVE,
                    value: gatewayStatus.DOES_NOT_HAVE
                },
            ],
            query: {},
        }
    },
    mounted() {
    }
    
}
</script>

<style>

</style>